import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener('DOMContentLoaded', function () {
	if (document.querySelector('#splide')) {
		new Splide('#splide', {
			type: 'loop', // 無限ループ
			perPage: 10, // 1ページに表示するアイテム数
			gap: '1rem', // スライド間のギャップ
			pagination: false, // ページネーションを非表示
			arrows: false, // 左右の矢印を非表示
			drag: false,
			autoScroll: {
				speed: 0.6, // スクロールの速さ (数字を調整可能)
				pauseOnHover: false // ホバー時にスライドを停止しない
			},
			breakpoints: {
				1200: {
					// 横幅が1400px以下の場合、8アイテム表示
					perPage: 8
				},
				1024: {
					// 横幅が1024px以下の場合、5アイテム表示
					perPage: 6
				},
				768: {
					// 横幅が768px以下の場合、3アイテム表示
					perPage: 5,
					autoScroll: {
						speed: 0.3
					}
				},
				480: {
					// 横幅が480px以下の場合、2アイテム表示
					perPage: 4,
					autoScroll: {
						speed: 0.3
					}
				}
			}
		}).mount({ AutoScroll });
	}

	if (document.querySelector('#splideCaseStudies')) {
		// 導入事例
		const splide = new Splide('#splideCaseStudies', {
			type: 'loop', // 無限ループ
			perMove: 1, // 1つずつ移動
			focus: 'center', // 常に中央に表示
			autoplay: true, // 自動再生
			pauseOnHover: false, // ホバー時に停止しない
			pauseOnFocus: false, // フォーカス時に停止しない
			interval: 5000, // 自動再生の間隔（ミリ秒）
			speed: 1000, // スライドの移動時間
			fixedWidth: 520, // スライドの幅を固定
			gap: '40px', // スライド間の余白
			padding: { left: '20%', right: '20%' },
			arrows: false, // デフォルトの矢印を非表示にする
			pagination: false, // デフォルトのページ送りも非表示
			breakpoints: {
				1024: {
					focus: false,
					fixedWidth: null,
					padding: { left: '35px', right: '35px' }
				}
			}
		}).mount();

		// カスタムボタンの操作
		const prevButton = document.getElementById('prevButton');
		const nextButton = document.getElementById('nextButton');

		prevButton.addEventListener('click', () => {
			splide.go('<'); // 前のスライドに移動
		});

		nextButton.addEventListener('click', () => {
			splide.go('>'); // 次のスライドに移動
		});

		// 矢印ボタンのラッパーを作成
		const wrapper = document.createElement('div');
		wrapper.classList.add('splide__arrow__wrap');

		// デフォルトのナビゲーションボタンを取得
		const prevArrow = document.querySelector('.splide__arrow--prev');
		const nextArrow = document.querySelector('.splide__arrow--next');

		if (prevArrow && nextArrow) {
			// ラッパーに矢印ボタンを追加
			wrapper.appendChild(prevArrow);
			wrapper.appendChild(nextArrow);

			// ラッパーをスライダーに追加
			const splideElement = document.querySelector('#splideCaseStudies');
			splideElement.appendChild(wrapper);
		}
	}
});
